import { useCallback } from 'react';
import type { IInboxRecordRef } from '@platform/dao';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { useGetCatalogQuery } from '@platform/state/api';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { typeSingular } from './typeSingular';
import { useLoadedModuleStrings } from './useLoadedModuleStrings';

/**
 * Підпис запису «Тип номер · Назва» («Завдання 101 · Підготувати довідку…», «Фракція 1 · Група…») для «Нещодавніх змін» і журналу аудиту
 * (прототип v4 auditVM: recType + code + title): однина типу з пакета модуля (рядки пакетів названих модулів довантажуються), голий номер.
 */
export function useTypedRecordLabel(ws: string, modules: readonly string[]): (record: IInboxRecordRef) => string {
  const lang = useAppSelector(selectLang);
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  const version = useLoadedModuleStrings(modules);
  return useCallback((r: IInboxRecordRef) => {
    const summary = catalog?.modules.find((m) => m.key === r.module);
    const type = r.recordType ? typeSingular(summary, r.recordType, lang) : '';
    const number = recordNumber({ code: r.code ?? 0, display: r.display ?? '' });
    return [[type, number].filter(Boolean).join(' '), r.title].filter(Boolean).join(' · ');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- version: нова тотожність після довантаження пакетів
  }, [catalog, lang, version]);
}
